/*
  NINI bejarasi ut - kollekciok es termekek tenyleges utvonala, fulenkent.
  Keszitette: Akos | branch: dev/akos | 2026-09-28
  Modositva: Akos | branch: dev/akos | 2026-09-28 - a tema termekszekciojanak breadcrumbjat keresi
  Modositva: Akos | branch: dev/akos | 2026-10-09 - kollekcios utvonal, history-visszaallitas es elkulonitett preview tarolas
  Modositva: Akos | branch: dev/akos | 2026-10-09 - header reset, kategoriankenti szintek, testverelemek csereje
*/
(() => {
  if (window.__niniBreadcrumbLoaded) return;
  window.__niniBreadcrumbLoaded = true;

  const STATE_KEY = 'niniJourney';
  const TYPES = new Set(['collection', 'product', 'search', 'page', 'blog', 'article']);
  const HEADER = 'nini-header, .nini-mobile-menu, nini-search, [data-nini-panel]';
  const CATEGORY_GROUP = '.nini-quick-links__list, .link-bar__linklist';
  let context;
  let trail = [];
  let storageKey;
  let limit = 6;

  const path = (value) => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      const pathname = url.pathname.replace(/\/collections\/[^/]+\/products\//, '/products/').replace(/\/$/, '') || '/';
      return pathname + (url.searchParams.has('q') ? '?q=' + encodeURIComponent(url.searchParams.get('q')) : '');
    } catch { return null; }
  };

  const read = (key) => {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; }
  };
  const write = (key, value) => {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* Private browsing: server fallback remains available. */ }
  };
  const cleanPeers = (urls) => Array.isArray(urls)
    ? [...new Set(urls.filter((url) => typeof url === 'string').map(path).filter(Boolean))] : [];
  const clean = (items) => Array.isArray(items) ? items.filter((item) =>
    item && TYPES.has(item.type) && typeof item.title === 'string' && item.title && typeof item.url === 'string' && path(item.url)
  ).map((item) => ({type: item.type, title: item.title, url: path(item.url), peers: cleanPeers(item.peers)})).slice(-limit) : [];

  const advance = (items, current, navigation) => {
    if (!TYPES.has(context.type) || !context.title) return context.type === 'cart' ? items : [];
    const entry = {type: context.type, title: context.title, url: current, peers: []};
    if (navigation?.mode === 'reset') return [entry];

    // Returning to an ancestor removes everything below that level.
    const ancestor = items.findIndex((item) => item.url === current);
    if (ancestor >= 0) return [...items.slice(0, ancestor), {...entry, peers: items[ancestor].peers}];

    // Lists visited on the parent page define siblings, even if the next page
    // also offers the same collections as quick links.
    const sibling = items.findIndex((item) => item.type === context.type && item.peers.includes(current));
    if (sibling >= 0) return [...items.slice(0, sibling), {...entry, peers: items[sibling].peers}];

    // Products are leaves: another product replaces the leaf, never extends it.
    while (items.at(-1)?.type === 'product') items = items.slice(0, -1);
    if (context.type === 'product') return [...items, entry].slice(-limit);

    if (navigation?.mode === 'down' && context.type === 'collection') {
      entry.peers = cleanPeers(navigation.peers);
      return [...items, entry].slice(-limit);
    }

    // Ordinary lateral navigation replaces the current level. Only explicit
    // collection navigation adds a level; this is not a page-visit history.
    if (items.at(-1)?.type === context.type) {
      entry.peers = items.at(-1).peers;
      items = items.slice(0, -1);
    } else if (context.type !== 'article') {
      items = [];
    }
    return [...items, entry].slice(-limit);
  };

  const render = () => {
    document.querySelectorAll('[data-nini-breadcrumb]').forEach((nav) => {
      const list = nav.querySelector('.breadcrumb__list');
      const home = list?.firstElementChild;
      if (!home || !trail.length) return;
      const items = [home.cloneNode(true)];
      trail.forEach((entry, index) => {
        const item = document.createElement('li');
        item.className = 'breadcrumb__item';
        const current = index === trail.length - 1;
        const link = document.createElement(current ? 'span' : 'a');
        link.className = 'breadcrumb__link';
        link.textContent = entry.title;
        if (current) link.setAttribute('aria-current', 'page');
        else link.href = entry.url;
        item.append(link);
        items.push(item);
      });
      list.replaceChildren(...items);
      nav.dataset.niniBreadcrumbSource = 'journey';
    });
  };

  const init = () => {
    try { context = JSON.parse(document.getElementById('nini-breadcrumb-context')?.textContent); } catch { return; }
    if (!context) return;
    limit = Math.max(2, Math.min(10, Number(context.depth) || 6));
    storageKey = 'nini-breadcrumb:v3:' + context.themeId + ':' + context.root;
    const current = path(context.url);
    if (!current) return;
    const saved = history.state?.[STATE_KEY];
    const previous = read(storageKey);
    const pending = read(storageKey + ':pending');
    const internal = document.referrer && path(document.referrer);
    const validClick = pending && pending.to === current && Date.now() - pending.time < 30000 &&
      previous?.url === pending.from && (!document.referrer || internal === pending.from);

    // Each browser history entry owns its trail, so Back/Forward and reload do not borrow a later page's path.
    if (!validClick && saved?.scope === storageKey && saved.url === current) {
      trail = clean(saved.trail);
    } else {
      trail = (validClick || (internal && previous?.url === internal)) ? clean(previous?.trail) : [];
      trail = advance(trail, current, validClick ? pending : null);
    }

    write(storageKey + ':pending', null);
    write(storageKey, {url: current, trail});
    try {
      history.replaceState({...history.state, [STATE_KEY]: {scope: storageKey, url: current, trail}}, '');
    } catch { /* The Liquid breadcrumb still works when history storage is unavailable. */ }
    if (context.type === 'collection' || context.type === 'product') render();
  };

  document.addEventListener('click', (event) => {
    if (!context || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const destination = path(link.href);
    if (destination) {
      const header = link.closest(HEADER);
      const group = link.closest(CATEGORY_GROUP);
      const peers = group ? Array.from(group.querySelectorAll('a[href]'), (item) => item.href) : [];
      write(storageKey + ':pending', {
        from: path(context.url), to: destination, time: Date.now(),
        mode: header ? 'reset' : group && context.type === 'collection' ? 'down' : 'auto',
        peers: cleanPeers(peers),
      });
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!context || event.defaultPrevented || !form.matches('form[role="search"]') || !form.closest(HEADER)) return;
    const destination = new URL(form.action, location.origin);
    destination.searchParams.set('q', new FormData(form).get('q') || '');
    write(storageKey + ':pending', {from: path(context.url), to: path(destination.href), time: Date.now(), mode: 'reset'});
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('pageshow', (event) => { if (event.persisted) init(); });
})();
